export default "__VITE_ASSET__901c5e1a__"